import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'employeeCodeTrim',
    standalone: true
})
export class EmployeeCodeTrim implements PipeTransform {

  transform(str: string, ...args: any[]): any {
    if(str?.includes('\\')) {
      return str?.split('\\')[1];
    }
    else {
      return str;
    }
  
  }

}